import React, { useState } from 'react';
import Select from "react-select";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from 'react-i18next';

const Activity = ({ activityRating, woContact, language, activityStatus, setActivityList, activityList, ativityLeadType }) => {
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        type: null,
        purpose: null,
        status: null,
        followup: null,
        visitDate: null,
        rating: null,
        wayofCOntact: null,
        language: null,
        remarks: '',
    });

    const [editIndex, setEditIndex] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (name, selected) => {
        setFormData(prev => ({ ...prev, [name]: selected }));
    };
    const handleAddOrUpdate = () => {

        if (editIndex !== null) {
            const updatedList = activityList.map((item, i) =>
                i === editIndex ? { ...formData } : item
            );
            setActivityList(updatedList);
            setEditIndex(null);
        } else {
            setActivityList(prev => [...prev, { ...formData }]);
        }

        setFormData({
            type: null,
            purpose: null,
            status: null,
            followup: null,
            visitDate: null,
            remarks: '',
        });
    };
    const handleEdit = (index) => {
        setFormData({ ...activityList[index] });
        setEditIndex(index);
    };
    const handleDelete = (index) => {
        const filtered = activityList.filter((_, i) => i !== index);
        setActivityList(filtered);
    };
    const handleDateChange = (input) => {
        const value = input?.target?.value || input.value;
        const name = input?.target?.name || input.name;
        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        setFormData(prev => ({ ...prev, [name]: updatedValue }));
    }
    const formatDate = (date) => date ? new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    }) : "";

    return (
        <div className="cost-center-section my-3">
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>

                <div className="form-group grid-contain ">

                    {/* Contact Type */}
                    <div className="d-flex">
                        <label className="form-label pt-1 start">{t('customerMaster.personalDetailsFields.type')}</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={ativityLeadType?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.type}
                            onChange={(selected) => handleSelectChange("type", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">{t('customerMaster.activityFields.rating')}</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={activityRating?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.rating}
                            onChange={(selected) => handleSelectChange("rating", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">{t('customerMaster.activityFields.wayOfContact')}</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={woContact?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.wayofCOntact}
                            onChange={(selected) => handleSelectChange("wayofCOntact", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">{t('customerMaster.activityFields.preferredLanguage')}</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={language?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.language}
                            onChange={(selected) => handleSelectChange("language", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">{t('customerMaster.activityFields.status')}</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={activityStatus?.map(country => ({ value: country?.value, label: country?.text }))}
                            onChange={(selected) => handleSelectChange("status", selected)}
                            value={formData.status}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">{t('customerMaster.activityFields.actionTakenRemarks')}</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">{t('customerMaster.activityFields.followup')}</label>
                        <DatePicker
                            selected={formData.followup}
                            onChange={(date) => handleDateChange({ name: 'followup', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">{t('customerMaster.activityFields.visitDate')}</label>
                        <DatePicker
                            selected={formData.visitDate}
                            onChange={(date) => handleDateChange({ name: 'visitDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                </div>

                {/* ADD / UPDATE BUTTON */}
                <div className='my-4'>
                    <div
                        className='mainbtnSecondary flex-end gap-2 col-2'
                        style={{ cursor: "pointer" }}
                        onClick={handleAddOrUpdate}
                    >
                        <FaPlus color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>
                            {editIndex !== null ? t('customerMaster.activityFields.updateActivity') : t('customerMaster.activityFields.addActivity')}
                        </div>
                    </div>
                </div>

                {/* TABLE */}
                <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                    <table className='table table-bordered gridshad'>
                        <thead className='dynoTable'>
                            <tr>
                                <th>{t('customerMaster.contactDetailsFields.action')}</th>
                                <th>{t('customerMaster.activityFields.wayOfContact')}</th>
                                <th>{t('customerMaster.personalDetailsFields.type')}</th>
                                <th>{t('customerMaster.activityFields.followup')}</th>
                                <th>{t('common.remarks')}</th>
                                <th>{t('customerMaster.activityFields.status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activityList.map((data, index) => (
                                <tr key={index}>
                                    <td className="text-center d-flex gap-3">
                                        <div className='center mt-2'>
                                            <FaEdit
                                                size={20}
                                                style={{ cursor: "pointer", color: "black" }}
                                                onClick={() => handleEdit(index)}
                                            />
                                        </div>
                                        <div className='center mt-2'>
                                            <FaTrash
                                                size={20}
                                                style={{ cursor: "pointer", color: "red" }}
                                                onClick={() => handleDelete(index)}
                                            />
                                        </div>
                                    </td>
                                    <td>{data.wayofCOntact?.label}</td>
                                    <td>{data.type?.label}</td>
                                    <td>{formatDate(data.followup)}</td>
                                    <td>{data.remarks}</td>
                                    <td>{data.status?.label}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default Activity;